

import React, { Component } from "react";
import "./BuyInput.css";
import ReactPaginate from "react-paginate";
import $ from "jquery";
import OutsideClickHandler from "react-outside-click-handler";
// import "../../Components/Config";
import { Row, Col } from "react-bootstrap";
import { FiThumbsUp } from "react-icons/fi";
import { NotificationManager } from "react-notifications";
import { Container } from "@mui/material";

class BuyInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      consumeruserparent: "consumer2",
      tenders: [],
      tendersFilter: [],
      offset: 0,
      tensdersPageCount: 1,
      perPage: 3,
      currentPage: 0,
      checked: false,
      postCategoryIdVlaue: "",
      InitialAccessToken: localStorage.getItem("GlobalAccess"),
      subCategoriesList: [],
      copyOfTenders: [],
      contentOwners: [],
    };
    this.handlePageClick = this.handlePageClick.bind(this);
    this.isComponentMounted = false
  }

  // Lifecycle method: Runs after the component mounts
componentDidMount() {
  this.postCategoryIdValue();
}

// Fetches category ID for "BUY-INPUT" and retrieves relevant content
postCategoryIdValue() {
  this.isComponentMounted = true;

  fetch(
      `${window.appConfig.getContentCategories}${window.appConfig.Relam}${window.appConfig.Relam}`,
      {
          method: "GET",
          headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.state.InitialAccessToken,
          },
      }
  )
      .then((res) => res.json())
      .then((result) => {
          if (!this.isComponentMounted) return; // Ensures the component is still mounted before updating state

          // Filters to find the category ID for "BUY-INPUT"
          const postid = result.categoryList.filter(
              (data) => data.categoryname === "BUY-INPUT"
          );

          if (postid.length === 0) {
              console.warn("No matching category found");
              return;
          }

          const categoryId = postid[0].categoryid;

          // Calls methods to fetch content based on the category ID
          this.viewAllSiteUpdates(categoryId);
          this.setState({
              postCategoryIdValue: categoryId, // Updates state with the category ID
          });
          this.adminsDropdownClick(categoryId);
          this.getCategorySubcategories(categoryId);
          this.ownerDropdownClick(categoryId);
      })
      .catch((err) => console.log("Fetch error:", err));
}

// Fetches content updates based on category ID
viewAllSiteUpdates(postid) {
  fetch(
      `${window.appConfig.getContentList}${window.appConfig.Relam}category/${postid}`,
      {
          method: "GET",
          headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.state.InitialAccessToken,
          },
      }
  )
      .then((res) => res.json())
      .then((result) => {
          this.setState({
              tenders: result.contentList,
              copyOfTenders: result.contentList,
              tensdersPageCount: Math.ceil(result.contentList.length / this.state.perPage),
          });
      });
}

// Fetches content creators for a specific category
adminsDropdownClick(catID) {
  fetch(
      `${window.appConfig.getContentCreator}${window.appConfig.Relam}contentcreators/${catID}`,
      {
          method: "GET",
          headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.state.InitialAccessToken,
          },
      }
  )
      .then((res) => res.json())
      .then((result) => {
          // Removes duplicates by using a Map
          const unique = [
              ...new Map(result.contentcreatorsList.map((data) => [data.contentcreatorid, data]))
                  .values(),
          ];
          this.setState({
              tendersFilter: unique,
          });
      })
      .catch((err) => console.log("Error fetching content creators:", err));
}

// Toggles dropdown for site organizations
organizationsDropdownClick() {
  $("#dropdownSite").toggle();
}

// Fetches content based on selected creator
organizationsOnClick(Creator) {
  fetch(
      `${window.appConfig.getContentonContentCreator}${window.appConfig.Relam}contentcreator/${Creator}/${this.state.postCategoryIdValue}`,
      {
          method: "GET",
          headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.state.InitialAccessToken,
          },
      }
  )
      .then((res) => res.json())
      .then((result) => {
          this.setState({
              tenders: result.contentList,
              tensdersPageCount: Math.ceil(result.contentList.length / this.state.perPage),
          });
      })
      .catch((err) => console.log("Error fetching creator content:", err));

  $("#dropdownSite").hide();
}

// Fetches subcategories based on category ID
getCategorySubcategories(catID) {
  if (!catID) return; // Prevents fetching if category ID is invalid

  fetch(
      `${window.appConfig.getContentSubcategories}${window.appConfig.Relam}${window.appConfig.Relam}${window.appConfig.Relam}${catID}`,
      {
          method: "GET",
          headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.state.InitialAccessToken,
          },
      }
  )
      .then((res) => res.json())
      .then((result) => {
          this.setState({
              subCategoriesList: result.contentsubcategories,
          });
      })
      .catch((err) => console.log("Error fetching subcategories:", err));
}

// Toggles dropdown for subcategories
subCategoriesDropdownClick() {
  $("#subCategoriesOfSiteUpdates").toggle();
}

// Filters tenders based on selected subcategory
subCategoriesOnClick(subCategory) {
  const subCategoriesOfAdsFilter = this.state.copyOfTenders.filter((data) =>
      data.contentsubcategory.toLowerCase().includes(subCategory.toLowerCase())
  );

  this.setState({
      tenders: subCategoriesOfAdsFilter,
      tensdersPageCount: Math.ceil(subCategoriesOfAdsFilter.length / this.state.perPage),
  });

  $("#subCategoriesOfSiteUpdates").hide();
}

// Sends a request to increment the like count for a content item
likeCount(contentid) {
  fetch(`${window.appConfig.contentLikeCount}${window.appConfig.Relam}${contentid}`, {
      method: "POST",
      headers: {
          "Content-Type": "text/plain",
          Authorization: "Bearer " + this.state.InitialAccessToken,
      },
  })
      .then((res) => res.text())
      .then((result) => {
          this.postCategoryIdValue(); // Refreshes category data after like update
          return NotificationManager.success(result);
      })
      .catch((err) => console.log("Error updating like count:", err));
}

// Fetches content owners based on category ID
ownerDropdownClick(catID) {
  fetch(
      `${window.appConfig.getAllContentOwnersBasedOnCategory}${catID}`,
      {
          method: "GET",
          headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.state.InitialAccessToken,
          },
      }
  )
      .then((res) => res.json())
      .then((result) => {
          // Removes duplicate owners
          const unique = [
              ...new Map(result.contentownerList.map((data) => [data.contentowner, data]))
                  .values(),
          ];
          this.setState({
              contentOwners: unique,
          });
      })
      .catch((err) => console.log("Error fetching content owners:", err));
}

// Toggles dropdown for content owners
contentOwnerDropdownClick() {
  $("#ContentOwnerOfSite").toggle();
}

// Fetches content based on selected content owner
getContentOwnerContent(Owner) {
  fetch(
      `${window.appConfig.getContentList}${window.appConfig.Relam}contentowner/${Owner}/${this.state.postCategoryIdValue}`,
      {
          method: "GET",
          headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.state.InitialAccessToken,
          },
      }
  )
      .then((res) => res.json())
      .then((result) => {
          this.setState({
              tenders: result.contentList,
              tensdersPageCount: Math.ceil(result.contentList.length / this.state.perPage),
          });
      })
      .catch((err) => console.log("Error fetching content owner data:", err));

  $("#dropdownOrganizations").hide();
}

// Lifecycle method: Runs before the component unmounts to clean up
componentWillUnmount() {
  this.isComponentMounted = false;
}

// Handles pagination click events
handlePageClick = (e) => {
  const selectedPage = e.selected;
  const offset = selectedPage * this.state.perPage;

  this.setState({
      currentPage: selectedPage,
      offset: offset,
  });
};

render() {
  const { tenders, subCategoriesList, contentOwners } = this.state;

  // Slice the tenders list to get only the items for the current page
  const siteUpdatesList = tenders.slice(
    this.state.offset,
    this.state.offset + this.state.perPage
  );

  return (
    <Container>
      <div
        id="tendersContainer"
        className="mb-lg-5 mb-4 mt-4 gbr-engage-container container-fluid"
      >
        {/* Buy Inputs Section */}
        <div className="mb-4">
          {/* Button to view all available buy inputs */}
          <div className="dropdown">
            <div className="navbarRight">
              <button
                className="btn btn-success homepageBtn"
                type="button"
                onClick={() =>
                  this.viewAllSiteUpdates(this.state.postCategoryIdVlaue)
                }
              >
                All Buy Inputs
              </button>
            </div>
          </div>

          {/* Dropdown for filtering by Publisher */}
          <div className="dropdown">
            <div className="dropdown homepage-nav-item">
              <div className="navbarRight">
                <button
                  className="btn btn-success homepageBtn"
                  type="button"
                  aria-haspopup="true"
                  aria-expanded="false"
                  onClick={() => this.organizationsDropdownClick()}
                >
                  Publisher
                </button>
              </div>
              <div
                className="dropdown-menu"
                id="dropdownSite"
                aria-labelledby="dropdownSite"
              >
                {/* List publishers dynamically */}
                {this.state.tendersFilter &&
                  this.state.tendersFilter.map((filter, i) => (
                    <li key={i}>
                      <a
                        className="dropdown-item"
                        role="button"
                        onClick={() =>
                          this.organizationsOnClick(filter.contentcreatorid)
                        }
                      >
                        {filter.contentcreatorid}
                      </a>
                    </li>
                  ))}
              </div>
            </div>
          </div>

          {/* Dropdown for filtering by Sub Categories */}
          <div className="dropdown">
            <div className="dropdown homepage-nav-item">
              <div className="navbarRight">
                <button
                  className="btn btn-success homepageBtn"
                  type="button"
                  aria-haspopup="true"
                  aria-expanded="false"
                  onClick={() => this.subCategoriesDropdownClick()}
                >
                  Sub Categories
                </button>
              </div>
              <div
                className="dropdown-menu"
                id="subCategoriesOfSiteUpdates"
                aria-labelledby="subCategoriesOfSiteUpdates"
              >
                {/* List subcategories dynamically */}
                {subCategoriesList &&
                  subCategoriesList.map((filter, i) => (
                    <li key={i}>
                      <a
                        className="dropdown-item"
                        role="button"
                        onClick={() =>
                          this.subCategoriesOnClick(
                            filter.contentsubcategoryname
                          )
                        }
                      >
                        {filter.contentsubcategoryname}
                      </a>
                    </li>
                  ))}
              </div>
            </div>
          </div>

          {/* Dropdown for filtering by Asset Type / Model */}
          <div className="dropdown">
            <div className="dropdown homepage-nav-item">
              <div className="navbarRight">
                <button
                  className="btn btn-success homepageBtn"
                  type="button"
                  aria-haspopup="true"
                  aria-expanded="false"
                  onClick={() => this.contentOwnerDropdownClick()}
                >
                  Asset type / Model
                </button>
              </div>
              <div
                className="dropdown-menu"
                id="ContentOwnerOfSite"
                aria-labelledby="ContentOwnerOfSite"
              >
                {/* List content owners dynamically */}
                {contentOwners &&
                  contentOwners.map((filter, i) => (
                    <li key={i}>
                      <a
                        className="dropdown-item"
                        role="button"
                        onClick={() =>
                          this.getContentOwnerContent(filter.contentowner)
                        }
                      >
                        {filter.contentowner}
                      </a>
                    </li>
                  ))}
              </div>
            </div>
          </div>
        </div>

        {/* Displaying the buy input's  */}
        <div className="adminTendersDiv">
          {/* If there are site updates, display them */}
          {siteUpdatesList.length !== 0 ? (
            <Row className="justify-content-center">
              {siteUpdatesList.map((tend, index) => (
                <Col md={6} lg={4} sm={12} xs={12} className="mb-4" key={index}>
                  <div className="community-cards w-100">
                    <div className="bordered-div"></div>
                    <div className="">
                      <div className="scrollable-container-mod scrollable-container pb-2">
                        <div className="community-card-body">
                          {/* Display content subcategory and like count */}
                          <div className="d-flex justify-content-between align-items-center mb-2 mt-2">
                            <span className="d-block">
                              {tend.contentsubcategory}
                            </span>
                            <p className="products-like mb-0 d-flex align-items-end">
                              <span
                                className="d-inline-block"
                                onClick={() => {
                                  this.likeCount(tend.contentid);
                                }}
                              >
                                <FiThumbsUp size={30} />
                              </span>
                              <small>{tend.likecount}</small>
                            </p>
                          </div>

                          {/* Content title and uploader details */}
                          <h2 className="mb-0">{tend.contentname}</h2>
                          <h5 className="mb-2">
                            Posted by <span>{tend.contentcreatorid}</span>,{" "}
                            {tend.timestamp}
                          </h5>

                          {/* Description link */}
                          <a
                            className="text-decoration-none"
                            href={tend.texturl}
                            target="_blank"
                          >
                            <h6 className="mb-3">{tend.contentdescription}</h6>
                          </a>

                          {/* Price information */}
                          <p>
                            <b>Price:</b> {tend.price}
                          </p>

                          {/* Display image */}
                          <img
                            className="img-thumbnail"
                            src={tend.locationurl}
                            width="100%"
                            height="250"
                            alt=""
                          />
                        </div>
                      </div>

                      {/* Buy button */}
                      <div className="community-button-container p-3 px-0 text-center mt-2">
                        <a
                          className="downloadDocument mt-0 signbutton"
                          href="http://cbn.gbrapp.com/"
                          target="_blank"
                        >
                          Buy
                        </a>
                      </div>
                    </div>
                  </div>
                </Col>
              ))}

              {/* Pagination Component */}
              <div className="paginationComponent">
                <ReactPaginate
                  previousLabel={"<<"}
                  nextLabel={">>"}
                  breakLabel={"..."}
                  breakClassName={"break-me"}
                  pageCount={this.state.tensdersPageCount}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={this.handlePageClick}
                  containerClassName={"pagination"}
                  subContainerClassName={"pages pagination"}
                  activeClassName={"active"}
                />
              </div>
            </Row>
          ) : (
            /* Message when no buy input's are found */
            <div className="card">
              <p className="card-body container-heading2">
                <b> Buy Input's Not Found</b>
              </p>
            </div>
          )}
        </div>

        {/* Outside Click Handler for closing dropdowns */}
        <OutsideClickHandler
          onOutsideClick={() => {
            $("#dropdownSite").hide();
            $("#subCategoriesOfSiteUpdates").hide();
            $("#ContentOwnerOfSite").hide();
          }}
        >
          <></>
        </OutsideClickHandler>
      </div>
    </Container>
  );
}

}

export default BuyInput;
